<template>
  <v-card>
    <!-- Header -->
    <v-card-title class="d-flex justify-space-between card-title">
      <div>
        Riwayat Penandaan Anatomi Tubuh
      </div>

      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-row no-gutters class="header-row">
      <div
        class="d-flex flex-row"
        v-for="(item, index) in headerData"
        :key="index"
      >
        <label for="">{{ item.label }}</label>
        <p>{{ item.text }}</p>
      </div>
    </v-row>
    <v-divider></v-divider>
    <!-- Content -->
    <v-card-text>
      <v-row no-gutters>
        <!-- List History -->
        <v-col cols="3" class="list-history">
          <div
            v-for="(item, idx) in history"
            :key="idx"
            :class="`card-history ${item.select ? 'active' : ''}`"
            @click="openHistory(idx)"
          >
            <label>{{ `${item.date}, ${item.time} - ${item.unit}` }}</label>
          </div>
        </v-col>
        <v-col cols="9" class="pa-6 anatomy-container">
          <div class="anatomy-content" v-if="anatomyContentRender">
            <anatomy-marker-content
              ref="anatomyContent"
              :showTextInformation="false"
              :marksProp="markProps"
              :gender="gender"
              :is-doctor="false"
              :tooltip-mode="'none'"
              :injury-types="injuryTypes"
              :readonly="true"
            />
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Constant from '@/const';
import AnatomyMarkerContent from './AnatomicalMark/AnatomyMarkerContent.vue';
const moment = require('moment-timezone');
const axios = require('axios');

export default {
  name: 'HistoryAnatomicalMark',
  props: {
    headerData: {
      type: Array,
      default: null,
    },
    idRegistration: {
      type: String,
      default: null,
    },
  },
  components: {
    AnatomyMarkerContent,
  },
  data() {
    return {
      anatomyContentRender: false,
      history: [],
      markProps: [],
      injuryTypes: [],
      patient: {
        gender: true,
        noRM: '',
        name: '',
        birthDate: '',
        age: '',
        communication_obstacles: '',
      },
    };
  },
  computed: {
    gender() {
      const gender = this.$store?.getters?.selectedPatient?.meta.gender;

      if (gender === 'Laki-laki' || gender === true) return true;
      else return false;
    },
  },
  methods: {
    async getInjuryType() {
      const response = await axios.get(
        Constant.apiUrl.concat('/master/injury-type'),
      );
      if (response) {
        this.injuryTypes = response.data.data;
      }
    },
    openHistory(idx) {
      this.history = this.history.map((v, i) => {
        const isSelect = i === idx;
        if (isSelect) {
          this.markProps = v.data;
        }
        return {
          ...v,
          select: isSelect,
        };
      });
    },
    setMarks(data) {
      return data.map((v, i) => {
        return {
          idx: i,
          bodyPart: v.image,
          position: {
            x: +v.position_x,
            y: +v.position_y,
          },
          woundType: v.injury_type,
          description: v.description,
          dimensions: {
            length: {
              value: v.wound_length,
              unit: v.wound_length_unit,
            },
            width: { value: v.wound_width, unit: v.wound_width_unit },
            depth: { value: v.wound_depth, unit: v.wound_depth_unit },
          },
        };
      });
    },
    async getHistory() {
      if (!this.$store?.getters?.selectedPatient?.id_emr) return;

      axios
        .get(
          Constant.apiUrl.concat(
            `/visit-history/anatomical-mark/${this.$store.getters.selectedPatient.id_emr}`,
          ),
        )
        .then(response => {
          this.history = response.data.data.map(v => {
            const dateMoment = moment(v.created_at);
            const isSelected =
              this.idRegistration.toString() === v.id_registration.toString()
                ? true
                : false;

            const marksData = this.setMarks(v.anatomical_markers);

            if (isSelected) this.markProps = marksData;

            return {
              date: dateMoment.format('DD MMM YYYY'),
              time: dateMoment.format('HH:mm'),
              unit: v.unit,
              select: isSelected,
              data: marksData,
            };
          });
        })
        .finally(() => {
          this.anatomyContentRender = true;
        });
    },
  },
  mounted() {
    this.getInjuryType();
    this.getHistory();
  },
};
</script>

<style lang="scss" scoped>
$border: #ededed;

.card-title {
  padding: 8px 20px !important;
}

.header-row {
  margin: 0 1.2vw;
  gap: 15px;
  label {
    color: #9e9e9e;
    margin-right: 8px;
  }
  p {
    color: #404040;
  }
}

.anatomy-content {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}

.anatomy-container {
  flex: 1;
  overflow-y: auto;
  max-height: calc(94vh - 200px);
  padding: 0 8px 0 0;

  &::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
    background-color: #d4d4d4;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgb(123, 121, 121);
    width: 5px;
    border-radius: 5px;
  }
}

.list-history {
  border-right: 1px solid $border;
  padding: 0px 24px !important;

  .card-history {
    font-size: 1.1vw;
    font-weight: 500;
    display: flex;
    align-items: start;
    border-radius: 12px;
    padding: 16px 16px;
    margin: 24px 0px;
    border: 1px solid $border;
    cursor: pointer;

    // .non-active {
    // }

    label {
      color: #404040;
      cursor: pointer;
    }
  }

  .card-history:hover {
    background-color: #ededed;
  }

  .active {
    background-color: #f0f8fe;
    border: 1px solid #1976d2;
  }
  .active:hover {
    background-color: #f0f8fe;
    border: 1px solid #1976d2;
  }
}
</style>
